import React, { useEffect } from 'react'
import * as actions from '../actions'
import { connect, useSelector } from 'react-redux'
import HoverMenu from '../components/HoverMenu'
import { AppState } from '../reducers'
import { Assortment, clearFilters, Product, setFilter } from '../services/assortment.service'
import _ from 'lodash'


type MenuProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const Menu = (props) => {

	const { gutterShapes, materials, grilles, tubeShapes, sizes, colors, products } = useSelector<AppState, Assortment>(state => state.filteredAssortment);
	const order = useSelector<AppState, {[key: number]: number}>(state => state.order);
	const { imgPath, iconsPath, filters } = props;

	useEffect(() => {
		const windowUrl = window.location.search;
		const params = new URLSearchParams(windowUrl); 
		const keys = Array.from(params.keys());
		const filter = {};
		_.forEach(keys, (key) =>{
			let value = params.get(key).toUpperCase();
			if (key === "gutter-shape" && _.includes(gutterShapes, value)){
				filter["gutterShape"] = value;
			} else if (key === "grille" && _.includes(grilles, value)){
				filter["grille"] = value;
			} else if (key === "tube-shape" && _.includes(tubeShapes, value)){
				filter["tubeShape"] = value;
			} else if (key === "material" && _.includes(materials, value)){
				filter["material"] = value;
			} else if (key === "size" && _.includes(sizes, value)){
				filter["size"] = value;
			} else if (key === "color-name"){
				value = params.get(key);
				value = value[0].toUpperCase() + value.slice(1);
				if (_.includes(Object.keys(colors), value)){
					filter["colorName"] = value;
				}
			}
		});
		let atLeastOne = false;
		_.forEach(products, (product) =>{
			let matches = true;
			_.forEach(Object.keys(filter), (key) => {
				if (product[key] !== filter[key]){
					matches = false;
				}
			})
			if (matches){
				atLeastOne = true;
			}
		})
		if (atLeastOne){
			_.forEach(Object.keys(filter), (key) => {
				setFilter(key, filter[key]);
			});
		}
	},[]);

	useEffect(() => {
		const areFiltersEmpty = Object.values(filters).every((val) => val === null);

		if (areFiltersEmpty) {
			const firstOrder = Object.keys(order)[0];

			if (firstOrder) {
				const product: Product = products[firstOrder];
				if (product && order[firstOrder] > 0) {
					setFilter('gutterShape', product.gutterShape);
					setFilter('grille', product.grille);
					setFilter('tubeShape', product.tubeShape);
					setFilter('material', product.material);
					setFilter('size', product.size);
					setFilter('colorName', product.colorName);
				}
			}
		}
	}, [order]);

	return (
		<div id="kr-menu">
			<div className="kr-menu-flex">
				<HoverMenu 
					id="kr-menu-gutterShape"
					className="kr-menu-filter"
					title="Kształt rynny" 
					list={gutterShapes}
					onSelect={(selected: string | null) => {setFilter('gutterShape', selected)}} 
					nullPosition="Wybierz" 
					selected={filters.gutterShape}
				/>
				<HoverMenu 
					id="kr-menu-grille"
					className="kr-menu-filter"
					title="Maskownica" 
					list={grilles}
					onSelect={(selected: string | null) => {setFilter('grille', selected)}} 
					nullPosition="Wybierz" 
					selected={filters.grille}
				/>
				<HoverMenu 
					id="kr-menu-tubeShape"
					className="kr-menu-filter"
					title="Kształt rury" 
					list={tubeShapes}
					onSelect={(selected: string | null) => {setFilter('tubeShape', selected)}} 
					nullPosition="Wybierz" 
					selected={filters.tubeShape}
				/>
				<HoverMenu 
					id="kr-menu-material"
					className="kr-menu-filter"
					title="Materiał" 
					list={materials}
					onSelect={(selected: string | null) => {setFilter('material', selected)}} 
					nullPosition="Wybierz" 
					selected={filters.material}
				/>
				<HoverMenu 
					id="kr-menu-size"
					className="kr-menu-filter"
					title="Rozmiar" 
					list={sizes}
					onSelect={(selected: string | null) => {setFilter('size', selected)}} 
					nullPosition="Wybierz" 
					selected={filters.size}
				/>
				<HoverMenu 
					id="kr-menu-colorName"
					className="kr-menu-filter"
					title="Kolor" 
					nullPosition="Wybierz" 
					selected={filters.colorName}
				>
					<div className="kr-hover-menu-body">
						<div className="kr-color-container">
						{filters.colorName !== null ? <div className="kr-menu-item-body cursor-pointer" key="color-null" onClick={() => {setFilter('colorName', null)}}><p className="kr-menu-item-text">Usuń</p></div> : ''}
						{
							Object.keys(colors).map(color => color !== filters.colorName ? <div className="kr-menu-item-body kr-menu-item-body-color cursor-pointer" key={`color-${color}`} onClick={() => setFilter('colorName', color)}>
								<p className="kr-menu-item-text">{color}</p>
								<img src={`${imgPath}colors/${colors[color]}`} width="35px" height="27px" alt="" />
							</div>: null)
						}
						</div>
					</div>
				</HoverMenu>
			</div>
			<div className="kr-menu-clear">
				<button onClick={clearFilters} style={
					Object.keys(filters).filter(key => filters[key] !== null).length === 0 ? {
						visibility: 'hidden'
					} : {}
				}>
					<img src={`${iconsPath}close.png`} alt="X" width={16} height={16}/>
					Wyczyść filtry
				</button>
			</div>
		</div>
	)
}

const mapStateToProps = (state: AppState) => ({
	imgPath: state.config.imgPath,
	iconsPath: state.config.iconsPath,
	filters: state.filters
})

const mapDispatchToProps = (dispatch: actions.Dispatch) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(Menu)
